import { useState } from "react";
import { usePermission } from "../../hooks/usePermission";
import { MyInventoryTab } from "./MyInventoryTab";
import { CatalogManagementTab } from "./CatalogManagementTab";

/**
 * Modul "Eigener Lagerbestand" (GTA-Roleplay). Eigenständig von der
 * regulären Lagerverwaltung. Zwei Bereiche: der eigene Bestand (für jeden
 * mit Modulzugriff) sowie die Gegenstands-/Kategorienverwaltung
 * (ausschließlich mit "personal_inventory.manage_catalog", per
 * Standardkonfiguration President/VizePresident).
 */
export default function PersonalInventory() {
  const canManageCatalog = usePermission("personal_inventory.manage_catalog");
  const [tab, setTab] = useState<"mine" | "catalog">("mine");

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-100">Eigener Lagerbestand</h1>
        <p className="text-sm text-gray-500 mt-1">Persönlicher RP-Bestand an virtuellen Gegenständen.</p>
      </div>

      {canManageCatalog && (
        <div className="flex gap-2 border-b border-surface-border">
          <button
            onClick={() => setTab("mine")}
            className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === "mine" ? "border-accent text-accent" : "border-transparent text-gray-500 hover:text-gray-300"}`}
          >
            Mein Bestand
          </button>
          <button
            onClick={() => setTab("catalog")}
            className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${tab === "catalog" ? "border-accent text-accent" : "border-transparent text-gray-500 hover:text-gray-300"}`}
          >
            Gegenstände verwalten
          </button>
        </div>
      )}

      {tab === "mine" ? <MyInventoryTab /> : <CatalogManagementTab />}
    </div>
  );
}
